module.exports = __webpack_public_path__ + "static/media/slack.8fc1aa66.jpg";